import { FormControl } from "@angular/forms";
import { trimWhiteSpaces } from "app/shared";

export function LengthValidator(control: FormControl, length: number): any {
	if (control.value) {
		const trimmedValue = trimWhiteSpaces(control.value)?.length;
		return trimmedValue === length
			? null
			: {
					simNumber: {
						valid: false,
						message: `Length should be ${length}`,
					},
					message: `Length should be ${length}`,
					// tslint:disable-next-line: indent
			  };
	}
}
